import { SafeUrl } from "@angular/platform-browser"
import { Team } from "./team.model"

type Gender = 'male' | 'female'

export class Player {
  _id : string=''
  name: string=''
  nation: string=''
  age: Date = new Date()
  foto?: SafeUrl
  imgUrl?: string
  gender: Gender | '' = ''
  commonName?: string=''
  commonPosition?: string=''
  currentTeam?: Team

  constructor()
  constructor(params: { name: string })
  constructor(params?: { name: string }) {
    if (params?.name) this.name = params.name
  }
}
